export default {
  transactionsFilter: {
    filters: "فیلترها",
    applyFilter: "اعمال فیلتر",
    depositFilterForm: {
      cryptoCurrency: "رمز ارز",
      currencyName: "نام ارز",
      ofDate: "از تاریخ",
      tillDate: "تا تاریخ",
      status: "وضعیت"
    },
    exchangeFilterForm: {
      fromCurrency: "از رمز ارز",
      currencyName: "نام ارز",
      toCryptoCurrency: "به رمز ارز",
      ofDate: "از تاریخ",
      tillDate: "تا تاریخ",
      status: "وضعیت"
    },
    filterForm: {
      time: "زمان",
      defaultDate: {
        week: "هفته قبل",
        month: "ماه قبل",
        threeMonth: "سه ماه قبل"
      },
      fromDate: "از تاریخ",
      tillDate: "تا تاریخ",
      status: "وضعیت",
      currencyFilterInput: {
        cryptoCurrency: "رمز ارز",
        currencyName: "نام ارز",
        searchCryptoPlaceholder: "جستجوی نام رمز ارز یا نام اختصاری",
        noCrypto: "ارزی موجود نیست"
      },
      fromToCurrenciesInput: {
        fromCryptoCurrency: "از رمز ارز",
        currencyName: "نام ارز",
        toCryptoCurrency: "به رمز ارز",
        searchInputPlaceholder: "جستجوی نام رمز ارز یا نام اختصاری",
        noCrypto: "ارزی موجود نیست"
      },
      withdrawFilterForm: {
        cryptoCurrency: "رمز ارز",
        currencyName: "نام ارز",
        fromDate: "از تاریخ",
        tillDate: "تا تاریخ",
        status: "وضعیت"
      },
      submitButton: "تایید"
    }
  },
  transactionDetail: {
    rialDeposit: "واریز ریالی",
    rialWithdrawal: "برداشت ریالی",
    transactionDetails: "جزئیات تراکنش",
    depositCryptoDetail: {
      amount: "مبلغ واریز شده",
      transactionId: "شناسه تراکنش",
      date: "تاریخ و ساعت",
      txid: "هش تراکنش (TXID)"
    },
    batchNumber: "شماره تراکنش (batch number)",
    voucherNumber: "ووچر",
    voucherCode: "کد فعال سازی",
    voucherAmount: "مقدار",
    depositRialDetail: {
      amount: "مبلغ واریز شده",
      transactionId: "شناسه تراکنش",
      type: "نوع",
      online: "آنلاین",
      offline: "آفلاین",
      date: "تاریخ و ساعت",
      paymentInformation: "اطلاعات پرداخت",
      from: "درگاه پرداخت",
      trackingNumber: "کد پیگیری",
      cardNumber: "شماره کارت",
      fromBank: "بانک مبدا",
      depositSystem: "نوع واریز"
    },
    exchangeDetail: {
      pay: "پرداختی",
      receive: "دریافتی",
      status: "وضعیت",
      transactionId: "شناسه تراکنش",
      date: "تاریخ و ساعت",
      fee: "کارمزد"
    },
    offlinePaymentDetail: {
      amount: "مبلغ واریز شده",
      date: "تاریخ و ساعت",
      fromBank: "بانک مبدا",
      depositSystem: "نوع واریز",
      trackingNumber: "کد پیگیری"
    },
    transferDetail: {
      transferred: "انتقال داده شده",
      transactionId: "شناسه تراکنش",
      date: "تاریخ و ساعت",
      description: "توضیحات"
    },
    withdrawCryptoDetail: {
      amount: "مقدار خالص دریافتی",
      transactionId: "شناسه تراکنش",
      date: "تاریخ و ساعت",
      fee: "کارمزد",
      grossAmount: "مقدار ناخالص (باکارمزد)",
      address: "آدرس کیف پول مقصد",
      txid: "هش تراکنش (TXID)",
      seeInDesc: "در توضیحات مشاهده کنید",
      description: "توضیحات"
    },
    withdrawRialDetail: {
      amount: "مبلغ برداشت شده",
      transactionId: "شناسه تراکنش",
      date: "تاریخ و ساعت",
      shebaNumber: "شماره شبا",
      trackingNumber: "کد پیگیری",
      seeInDesc: "در توضیحات مشاهده کنید",
      description: "توضیحات"
    },
    cardNumber: "شماره کارت",
    datailsTitle: "توضیحات"
  },
  depositTable: {
    filters: "فیلترها",
    clearAllFilters: "حذف فیلتر",
    all: "همه",
    offline: "آفلاین",
    online: "آنلاین",
    to: "تا",
    from: "از",
    transactionId: "شناسه تراکنش",
    depositAmount: "مبلغ واریزی",
    date: "زمان",
    time: "ساعت",
    type: "نوع",
    status: "وضعیت",
    action: "عملیات",
    crypto: "رمز ارز",
    amount: "مقدار"
  },
  detailsInTable: {
    details: "جزییات"
  },
  exchangeTable: {
    filters: "فیلترها",
    clearAllFilters: "حذف فیلتر",
    all: " همه",
    from: "از",
    to: "تا",
    transactionId: "شناسه تراکنش",
    payment: "پرداختی",
    toCurrency: "به",
    executed: "پرداختی",
    date: "زمان",
    time: "ساعت",
    status: "وضعیت",
    action: "عملیات"
  },
  transferTable: {
    filters: "فیلترها",
    clearAllFilters: "حذف فیلتر",
    all: "همه",
    from: "از",
    to: "تا",
    crypto: "رمز ارز",
    amount: "مقدار",
    transactionId: "شناسه تراکنش",
    date: "زمان",
    time: "ساعت",
    status: "وضعیت",
    action: "عملیات"
  },
  verifyInTable: {
    pay: "رفتن به درگاه",
    completeOrder: "تکمیل سفارش",
    smsConfirmation: "تایید هویتی"
  },
  withdrawalTable: {
    filters: "فیلترها",
    clearAllFilters: "حذف فیلتر",
    all: "همه",
    from: "از",
    to: "تا",
    transactionId: "شناسه تراکنش",
    withdrawalAmount: "مبلغ برداشتی",
    date: "زمان",
    time: "ساعت",
    status: "وضعیت",
    action: "عملیات",
    crypto: "رمز ارز",
    amount: "مقدار"
  },
  categories: [
    { to: "deposits", tooltip: "واریزها" },
    { to: "withdrawals", tooltip: "برداشت‌ها" },
    { to: "exchanges", tooltip: "معاملات" },
    { to: "transfers", tooltip: "انتقال" }
  ]

  // categories: [
  //   { to: "deposits?category=IRR", tooltip: "واریز ریال" },
  //   { to: "deposits?category=cryptoCurrency", tooltip: "واریز رمزارز" },
  //   { to: "withdrawals?category=IRR", tooltip: "برداشت ریال" },
  //   { to: "withdrawals?category=cryptoCurrency", tooltip: "برداشت رمزارز" },
  //   { to: "exchanges", tooltip: "معاملات" },
  //   { to: "transfers", tooltip: "انتقال" }
  // ]
};
